import { useEffect } from "react"
import { atomWithImmer } from "jotai-immer"
import { useImmerAtom } from "jotai-immer"

export type DashboardConfig = {
  isFullscreen?: boolean
  showLegend?: boolean
  selectedNodes?: string[]
  selectedNodeIndex?: number
  showHistoric?: boolean
  showAsTable?: boolean
  selectedAggregate?: string[]
  hiddenDatasets?: string[]

  // applicable only for bar chart
  stacked?: boolean
  showAsPercentage?: boolean
}

export const dashboardConfigAtom = atomWithImmer<DashboardConfig>({})

if (process.env.NODE_ENV !== "production") {
  dashboardConfigAtom.debugLabel = "dashboardConfigAtom"
}

export function useDashboardConfig(initConfig?: Partial<DashboardConfig>) {
  const [cfg, updateCfg] = useImmerAtom(dashboardConfigAtom)

  useEffect(() => {
    if (initConfig) {
      updateCfg((draft) => {
        for (const key of Object.keys(initConfig) as (keyof DashboardConfig)[]) {
          setIfUndefined(draft, initConfig, key)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- initialize it only once
  }, [])

  return [cfg, updateCfg] as const
}

function setIfUndefined<Key extends keyof DashboardConfig>(
  draft: DashboardConfig,
  initConfig: Partial<DashboardConfig>,
  key: Key,
) {
  if (draft[key] === undefined && initConfig[key] !== undefined) {
    draft[key] = initConfig[key]
  }
}
